import * as React from 'react'

import { Loader } from '~/client/src/shared/components/Loader'
import { cn } from '~/client/src/shared/utils/cn'

interface IProps {
  hint: string
  className?: string
}

/**
 * The shared brand Loader (the one TenantRoutingView and Redirector show), laid
 * out with Tailwind so it never falls back to Loader's legacy default classes.
 */
export function PortalLoader({ hint, className }: IProps) {
  return (
    <Loader
      hint={hint}
      className={cn(
        'tw:flex tw:flex-col tw:items-center tw:justify-center tw:gap-3 tw:text-center tw:text-app-body tw:text-muted-foreground',
        className,
      )}
    />
  )
}
